import { API_BASE_URL } from "@/api/api.config";

/**
 * Get parsed URL using Path Params
 * @description Replace the URL with the given replacers
 * @example getParsedURL('https://api.example.com/v1/users/[id]', [{ id: '123' }])
 */
const getParsedURL = (
  url: string,
  urlReplacers: Array<Record<string, unknown>>,
  forTests?: boolean,
) => {
  urlReplacers.forEach((replacer) => {
    Object.entries(replacer).forEach(([key, value]) => {
      if (value) {
        url = url.replace(`[${key}]`, String(value));
      } else {
        url = url.replace(`/[${key}]`, "");
      }
    });
  });

  if (forTests) {
    return `${API_BASE_URL}${url}`;
  }

  return url;
};
export default getParsedURL;
